//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gtmGlobal } from '~/helpers/gtm';

export default {
	data () {
		return {
			cookiesGTM: false,
		};
	},

	async fetch () {
		if (this.$cookies.get('cookies-gtm') === 1) {
			this.cookiesGTM = true;
		}
	},

	head () {
		return {
			title: this.$config.webTitle[this.$i18n.locale] + ' - Cookies',
			meta: [
				{
					name: 'description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
				{
					property: 'og:title',
					content: this.$config.webTitle[this.$i18n.locale],
				},
				{
					property: 'og:description',
					content: this.$config.webDescription[this.$i18n.locale],
				},
			],
		};
	},

	methods: {
		cookiesAcceptAll () {
			this.$cookies.set('cookies-necessary', 1);
			this.$cookies.set('cookies-accept-all', 1);
			this.$cookies.set('cookies-gtm', 1);
			gtmGlobal({ $gtm: this.$gtm, $config: this.$config, locale: this.$i18n.locale });

			this.$router.push('/');
		},

		cookiesNecessary () {
			this.$cookies.set('cookies-necessary', 1);
			this.$cookies.set('cookies-gtm', 0);
			this.$cookies.set('cookies-accept-all', 0);

			this.$router.push('/');
			window.location.reload();
		},

		cookiesCustom () {
			this.$cookies.set('cookies-necessary', 1);
			this.$cookies.set('cookies-gtm', Number(this.cookiesGTM));
			if (this.cookiesGTM) {
				gtmGlobal({ $gtm: this.$gtm, $config: this.$config, locale: this.$i18n.locale });
			}

			this.$router.push('/');
		},
	},
};
